export default __webpack_public_path__ + "static/media/content-image.ac812012.png";